export type ExperienceState =
  | "attract"
  | "story"
  | "hero"
  | "catalog"
  | "recovering";

export type QualityTier = "high" | "medium" | "low" | "reduced-motion";

export type CameraStatus =
  | "idle"
  | "requesting"
  | "active"
  | "denied"
  | "unavailable"
  | "error";

export type GestureName =
  | "None"
  | "Open_Palm"
  | "Closed_Fist"
  | "Pointing_Up"
  | "Thumb_Up"
  | "Victory"
  | "Pinch"
  | "Swipe_Left"
  | "Swipe_Right"
  | "Two_Hand_Spread";

export interface NormalizedPoint {
  readonly x: number;
  readonly y: number;
  readonly z: number;
  readonly visibility?: number;
}

export interface CameraSignal {
  readonly presence: boolean;
  readonly bodyCenter: Readonly<{ x: number; y: number }>;
  readonly poseLandmarks: ReadonlyArray<NormalizedPoint>;
  readonly handLandmarks: ReadonlyArray<ReadonlyArray<NormalizedPoint>>;
  readonly gesture: GestureName;
  readonly confidence: number;
  readonly timestamp: number;
}

export interface SceneProgress {
  readonly normalized: number;
  readonly chapterIndex: number;
  readonly chapterProgress: number;
}

export interface AssetLod {
  readonly level: "hero" | "catalog" | "crowd";
  readonly uri: string | null;
  readonly triangleBudget: Readonly<[number, number]>;
  readonly sizeBudgetMb: Readonly<[number, number]>;
}

export interface AssetManifestEntry {
  readonly assetId: string;
  readonly chineseName: string;
  readonly category: string;
  readonly sourceFile: string;
  readonly sourceFormat: "NX_PRT" | "STEP" | "GLB";
  readonly sourceHash: string | null;
  readonly rightsStatus: "unverified" | "internal" | "cleared";
  readonly conversionStatus: "pending" | "trial" | "ready" | "failed";
  readonly isHero: boolean;
  readonly materialPreset: string;
  readonly lods: ReadonlyArray<AssetLod>;
}

export interface ExperienceChapter {
  readonly id: string;
  readonly index: number;
  readonly eyebrow: string;
  readonly title: string;
  readonly marker: string;
  readonly state: ExperienceState;
}

export const EMPTY_CAMERA_SIGNAL: CameraSignal = {
  presence: false,
  bodyCenter: { x: 0.5, y: 0.5 },
  poseLandmarks: [],
  handLandmarks: [],
  gesture: "None",
  confidence: 0,
  timestamp: 0,
};

